"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _ModalComponent.default;
  }
});

var _ModalComponent = _interopRequireDefault(require("./Modal-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }